import {Component, Input} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {PrlLanguageService} from '../../services/prl-language.service';

@Component({
    selector: 'prl-label',
    standalone: false,
    template: '<span [innerHTML]="getLabel()"></span>'
})
export class PrlLabelComponent {

  @Input() value: string = '';

  constructor(private prlLanguageService: PrlLanguageService,
              private sanitizer: DomSanitizer) {
  }

  getLabel(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.prlLanguageService.getLabel(this.value));
  }
}
